import Button from "Components/Button";
import { useRouter } from "next/router";
import { FC } from "react";
import { ButtonText } from "./ArticleButton.styled";

interface Props {
  data: {
    url?: string;
    title?: string;
  };
}
const ArticleButton: FC<Props> = ({ data }) => {
  const { push } = useRouter();
  if (!data.url) {
    return null;
  }
  return (
    <Button
      handleClick={() => push(data.url ? data.url : "/")}
      buttonStyles="primary"
    >
      <ButtonText> {data.title}</ButtonText>
    </Button>
  );
};

export default ArticleButton;
